/*
 * @Author: Teemo Ding
 * @Date: 2021-12-01 11:57:07
 * @LastEditTime: 2022-06-15 11:06:05
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/DirectDiscount/Detail/BasicInfo/index.tsx
 */
import React from 'react';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import BasicComp from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/BasicInformation';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const BasicInfo = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    activeTime,
    setActiveTime,
    activeTimeError,
    setActiveTimeError,
    form,
    isPrimary,
    setHasModified,
    scTimezoneUTC,
    disableEdit,
    onCurrencyChange,
  } = props;
  return (
    <SectionWrapper
      id={'DirectDiscountBasicInfo'}
      containerClassName={`${css.sectionContainer} ${css.sectionContainerWeights}`}
      title={getI18n('general.basicInformation')}>
      <BasicComp
        setHasModified={setHasModified}
        activeTime={activeTime}
        setActiveTime={setActiveTime}
        activeTimeError={activeTimeError}
        setActiveTimeError={setActiveTimeError}
        form={form}
        scTimezoneUTC={scTimezoneUTC}
        isPrimary={isPrimary}
        disableEdit={disableEdit}
        onCurrencyChange={onCurrencyChange}
      />
    </SectionWrapper>
  );
};
export default BasicInfo;
